import type { FonteTribunal } from '@/api/fontesTribunais';

const GRAUS: Record<string, string> = {
  PRIMEIRO_GRAU: '1º grau',
  SEGUNDO_GRAU: '2º grau',
  TERCEIRO_GRAU: 'Superior',
};

export function rotuloGrau(instancia: string | null): string {
  if (!instancia) return '—';
  return GRAUS[instancia] ?? instancia.replace(/_/g, ' ').toLowerCase();
}

/** Motivo de não poder ligar a conferência; `null` quando pode (ou já está ligada). */
export function bloqueioConferencia(fonte: FonteTribunal): string | null {
  if (fonte.consulta_nativa_habilitada) return null;
  if (!fonte.consulta_nativa_suportada) return 'Sistema sem conferência';
  if (!fonte.url) return 'Cadastre a URL';
  return null;
}

/** Motivo de não poder ligar o peticionamento no sistema; `null` quando pode (ou já está ligado). */
export function bloqueioPeticionamento(fonte: FonteTribunal): string | null {
  if (fonte.peticionamento_nativo_habilitado) return null;
  if (fonte.sistema_processual !== 'PJE') return 'Só no PJe';
  if (!fonte.url) return 'Cadastre a URL';
  return null;
}

export type FiltroFontes = 'com_processos' | 'habilitadas' | 'todas';

export function filtrarFontes(fontes: FonteTribunal[], busca: string, filtro: FiltroFontes): FonteTribunal[] {
  const termo = busca.trim().toLowerCase();
  return fontes
    .filter((f) => {
      if (filtro === 'com_processos' && f.tramitacoes === 0) return false;
      if (filtro === 'habilitadas' && !f.consulta_nativa_habilitada && !f.peticionamento_nativo_habilitado) {
        return false;
      }
      if (!termo) return true;
      return [f.tribunal_sigla, f.sistema_processual, f.url, f.id_fonte, rotuloGrau(f.instancia)]
        .some((campo) => campo?.toLowerCase().includes(termo));
    })
    .sort(
      (a, b) =>
        (a.tribunal_sigla ?? '').localeCompare(b.tribunal_sigla ?? '') ||
        (a.instancia ?? '').localeCompare(b.instancia ?? '') ||
        (a.sistema_processual ?? '').localeCompare(b.sistema_processual ?? ''),
    );
}
